import banjixiangqing from './banjixiangqing.vue'
import banjiall from './banjiall.vue'
import banjiupdate from './banjiupdate.vue'
export default {
  components: {
    banjixiangqing, banjiall, banjiupdate
  },
  data() {
    return {
      banjiname: '',
      banjiid: '',
      dialogVisible: false,
      tableData1: [],
      total: 0,
      length: 15,
      offset: 0,
      currentPage: 1,
      value: '',
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      // 控制弹窗自动分配班级弹窗的变量
      dialogAllocationClass: false,
      xiangqing: '',
      bianji: '',
      peizhi: '',

      restaurants: [],
      state1: '',

      //添加页面变量
      search: '',
      shop_search: '',
      value1: '',
      value2: '',
      value3: '',
      value5: '',
      currentPage: 0,
      //添加页面变量end

      // 辅导员列表
      instructorList: [],
      // 产品列表
      productList: [],
      // 辅导员
      instructor: null,
      // 产品
      product: null,
      // 班级人数
      count: null,
			//禁止开班前时间点击
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 8.64e7
				}
			}
    }
  },
  methods: {
    // 搜索框函数
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    // 分页函数
    handleCurrentChange(val) {
      this.offset = (val - 1) * this.length
      this.gethttp()
    },
    handleSizeChange(val) {
      this.offset = 0
      this.length = val
      this.gethttp()
    },
    //分页end
    // 删除成功提示
    succeed() {
      this.$alert('删除成功！', '提示', {
        confirmButtonText: '确定',
      });

    },
    // 删除失败提示
    defeated() {
      this.$alert('删除失败！', '提示', {
        confirmButtonText: '确定',
      });
    },

    particulars(index, row) {
      // console.log(row);
      this.$router.push({

        name: 'particulars',

        params: { item: row }

      })
    },

    // 成员配置
    all(index, row) {
      // console.log(row.product_id);
      this.peizhi = row
      this.dialogVisible4 = true
    },
    // 添加
    addbanji(index, row) {
      this.value1 = ''
      this.value2 = ''
      this.value3 = ''
      this.value5 = ''
      this.dialogVisible3 = true
    },
    // 编辑
    update(index, row) {
      this.bianji = row

      this.value1 = this.bianji.name
      this.value2 = this.bianji.product_name
      this.value3 = this.bianji.instructor_name
      this.value5 = this.bianji.start_time


      this.dialogVisible2 = true
    },
    // 详情
    banjixiangqiang(index, row) {
      this.xiangqing = row
      this.dialogVisible1 = true
    },

    // 获取班级列表信息(分页)
    gethttp() {
      this.$post('class/search', {
        offset: this.offset,
        length: this.length,
        token: this.$store.state.authority_management,
      }).then(res => {

        // console.log(res.data.result.data)
        this.tableData1 = res.data.result.data
        this.total = res.data.result.total

        this.tableData1 = res.data.result.data.map((res, index) => {

          if (res.state == 1) {
            res.state = '上架'
          } else {
            res.state = ''
          }
          return res;
        })
        this.total = res.data.result.total


      })
    },
    // 获取班级搜索列表信息
    gethttp1() {
      this.$post('class/search', {
        offset: 0,
        length: 999,
        token: this.$store.state.authority_management,
      }).then(res => {
        this.restaurants = res.data.result.data.map((res, index) => {
          res.value = res.name;
          res.address = res.project_name;
          return res;
        })

      })
    },
    // 搜索
    sousuo() {
      // console.log(this.state1)
      if (this.state1) {
        this.$post('class/search', {
          offset: 0,
          length: 999,
          token: this.$store.state.authority_management,
          name: this.state1
        }).then(res => {
          this.tableData1 = res.data.result.data
          this.total = 0
        })
      } else {
        this.gethttp();

      }
    },

    //获取产品名
    getshop_search() {
      this.$post('products/shop_search', {
        offset: 0,
        length: 9999,
        token: this.$store.state.authority_management,
        shop_id: this.$store.state.store.id
      }).then(res => {
        this.shop_search = res.data.result.data
        for(let val of this.shop_search){
          if(val.name=='项目式产品'){
          }
        }
      })
    },
    
    //获取辅导员姓名
    getsearch() {
      this.$post('instructor/search', {
        offset: 0,
        length: 999,
        token: this.$store.state.authority_management,
        shop_id: this.$store.state.store.id,
      }).then(res => {
        this.search = res.data.result.data
      })
    },
    //添加班级
    add() {
      let fl = false
      let text = "请输入"
      // 校验
      if (this.value1 == '' || this.value1 == null) {
        text = text + '__[班级名称]'
      }
      if (this.value2 == '' || this.value2 == null) {
        text = text + '__[产品名称]'
      }
      if (this.value3 == '' || this.value3 == null) {
        text = text + '__[辅导员]'
      }
      if (this.value5 == '' || this.value5 == null) {
        text = text + '__[开班时间]'
      }
      if (text == '请输入') {
        fl = true
      } else {
        this.tishi(text)
      }

      if (fl) {
        this.$post('class/create', {
          name: this.value1,
          product_id: this.value2,
          instructor_id: this.value3,
          start_time: this.value5,
          token: this.$store.state.authority_management,
        }).then(res => {
          if (res.data.status == 'success') {
            this.success('添加成功！')
            this.gethttp()
            this.dialogVisible3 = false
            this.value1 = ''
            this.value2 = ''
            this.value3 = ''
            this.value5 = ''
          } else {
            this.tishi('添加失败！')
          }

        })
      }

    },
    //////////////////////////////////////////////////////添加班级js end///////////////////////////////////////////////////////////////////////
    //更新数据库
    gengxinshuju() {
      let fl = false
      let text = "请输入"


      if (this.value2 == this.bianji.product_name) {
        this.value2 = this.bianji.product_id
      }
      if (this.value3 == this.bianji.instructor_name) {
        this.value3 = this.bianji.instructor_id
      }



      // 校验
      if (this.value1 == '' || this.value1 == null) {
        text = text + '__[班级名称]'
      }
      if (this.value2 == '' || this.value2 == null) {
        text = text + '__[产品名称]'
      }
      if (this.value3 == '' || this.value3 == null) {
        text = text + '__[辅导员]'
      }
      if (this.value5 == '' || this.value5 == null) {
        text = text + '__[开班时间]'
      }
      if (text == '请输入') {
        fl = true
      } else {
        this.tishi(text)
      }

      if (fl) {

        this.$post('class/edit', {
          id: this.bianji.id,
          name: this.value1,
          product_id: this.value2,
          instructor_id: this.value3,
          start_time: this.value5,
          token: this.$store.state.authority_management,
        }).then(res => {
          if (res.data.status == 'success') {
            this.success('修改成功！')
            this.init()
            this.dialogVisible2 = false
          } else {
            this.tishi('修改失败！')
          }

        })
      }
    },
    // 删除
    Delete() {

      this.$post('class/delete', {
        id: this.banjiid,
        token: this.$store.state.authority_management,
      }).then(res => {
        if (res.data.status == 'success') {
          this.gethttp()

        } else {
          this.defeated()
        }

      })
      this.dialogVisible = false
    },

    //删除提示框
    yonghujiaoyuan(index, row) {
      this.banjiname = row.name
      this.banjiid = row.id

      this.$confirm('此操作将永久删除_' + this.banjiname + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.Delete()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },



    // 初始化
    init() {
      this.gethttp();
      this.gethttp1();
    },
    // 提示消息
    tishi(text) {
      this.$message.error(text);
    },
    // 成功消息
    success(text) {
      this.$message({
        message: text,
        type: 'success'
      });
    },
    
    // 自动分配班级
    autoAllocationClass(instructor_id, product_id, count){
      // 校验数据
      let message = ''
      if (instructor_id === null) {
        message = '请选择辅导员'
      } else if (product_id === null) {
        message = '请选择产品'
      } else if (count === null) {
        message = '请输入班级人数'
      } else if (count * 1 <= 0) {
        message = '输入的班级人数要大于0'
      }
      if (message !== '') {
        this.$message({
          type: 'error',
          message: message
        })
        return
      }

      const data = {
        token: this.$store.state.authority_management,
        instructor_id: instructor_id,
        product_id: product_id,
        count: count
      }
      this.$post('class/autoCreate', data).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: '自动分配班级成功'
          })
          this.instructor = null
          this.product = null
          this.count = null
          this.gethttp()
        }
      })
    },

    // 获取辅导员列表
    getInstructorList() {
      const data = {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 9999,
        shop_id: this.$store.state.store.id
      }
      this.$post('instructor/search', data).then(res => {
        if (res.status === 200) {
          this.instructorList = res.data.result.data
        }
      })
    },

    // 获取产品列表
    getProductList() {
      const data = {
        token: this.$store.state.authority_management,
        offset: 0,
        length: 9999,
        name: '',
        shop_id: this.$store.state.store.id
      }
      this.$post('products/shop_search', data).then(res => {
        if (res.status === 200) {
          this.productList = res.data.result.data
          // console.log(this.productList)
        }
      })
    }
  },

  created() {
    this.init()
    this.getshop_search();
    this.getsearch();
    // 获取辅导员列表
    this.getInstructorList()
    // 获取产品列表
    this.getProductList()
  },
  mounted() {

  }


}